/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Checkbox,
    Divider,
    Dropdown,
    Form,
    Input,
    Menu,
    Select,
    Space,
    Spin,
    Tag,
    TreeSelect,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import DataFlowService from '../../services/DataFlow.service';
import noImage from './../../assets/Images/svg/noImage.svg';
import circlePlus from './../../assets/Images/svg/circle-plus.svg';
import ModalAddApplication from './components/ModalAddApplication';
import ModalDiscardChanges from '../../components/Shared/modal/discardChanges';
import { useBlocker } from '../../util/usePrompt';
import ModalConfirm from '../../components/Shared/modal/confirm';
import ConsentService from '../../services/Consent.service';
import GlobalService from '../../services/Global.service';
import { ROUTER } from '../../constants/router';
import useNotify from '../../context/Notification/useNotify';
import ModalDelete from '../../components/Shared/modal/delete';
import EditorPrivacy from '../../components/Shared/forms/EditorPrivacy';
const { Option } = Select;

export default function ConsentForm() {
    const { t, i18n } = useTranslation();
    const lang = i18n?.language;
    const { id } = useParams();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const notify = useNotify();
    const [consentDuration, setConsentDuration] = useState('0');

    const [currentSelectList, setCurrentSelectList] = useState();
    const [applicationList, setApplicationList] = useState([]);
    const [isAccept, setIsAccept] = useState(false);
    const [duration, setDuration] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [dsType, setDsType] = useState([]);
    const [activitySelection, setActivitySelection] = useState();
    const [departmentSelection, setDepartmentSelection] = useState([]);
    const [consentDetail, setConsentDetail] = useState();

    const [loadingSave, setLoadingSave] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openAddApplication, setOpenAddApplication] = useState(false);
    const [openPublish, setOpenPublish] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [publishData, setPublishData] = useState();
    const [applicationData, setApplicationData] = useState();
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [isChangeLocation, setIsChangeLocation] = useState();
    const [nextLocation, setNextLocation] = useState();
    const [disabledIsConsent, setDisabledIsConsent] = useState(false);

    const menu = (item) => (
        <Menu
            items={[
                {
                    label: (
                        <a
                            onClick={() => {
                                setApplicationData(item);
                                setOpenAddApplication(true);
                            }}
                        >
                            {t('common.Edit')}
                        </a>
                    ),
                },
                {
                    label: (
                        <a
                            onClick={() => {
                                setOpenDelete(true);
                                setDataObject(item);
                            }}
                        >
                            {t('common.Delete')}
                        </a>
                    ),
                },
            ]}
        />
    );

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };
    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const getConsentDetail = async (id) => {
            if (id !== 'new') {
                const { data } = await ConsentService.getConstentDetail(id);
                const item = data?.resultData;
                form.setFieldsValue({
                    departmentIds: item?.departmentIds,
                    activityIds: item?.activityIds,
                    consentType: item?.consentType,
                    consentNameTh: item?.consentNameTh,
                    consentNameEn: item?.consentNameEn,
                    purposeTh: item?.purposeTh,
                    purposeEn: item?.purposeEn,
                    expirationYear: item?.expirationYear,
                    expirationMonth: item?.expirationMonth,
                    expirationDate: item?.expirationDate,
                });
                await setDepartmentSelection(item?.departmentIds);
                await getActivity(item?.departmentIds);
                await setActivitySelection(item?.activityIds);
                await getDataSubject(item?.activityIds);
                await setIsAccept(item?.isConsented);
                await setDuration(item?.noExpirationDate);
                await setConsentDuration(item?.consentDuration);
                if (item?.consentType !== 'Consent') {
                    setDisabledIsConsent(true);
                }
                const applicationRelatedSelect = [];
                item?.applicationRelated?.forEach((value) => {
                    applicationRelatedSelect?.push(value?.applicationId);
                });
                setChange(false);
                setConsentDetail(item);
                setCurrentSelectList(applicationRelatedSelect);
            }
        };
        getConsentDetail(id);
    }, [id]);

    // Department
    const getDepartment = async () => {
        try {
            const { data } = await DataFlowService.getAllDepartmentList();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        title: lang === 'en' ? element.nameEn : element.nameTh,
                        value: element.departmentId,
                    });
                });
                setDepartmentList(option);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getDepartment();
    }, [lang]);

    // Activity
    const getActivity = async (departmentSelection) => {
        try {
            const { data } = await ConsentService.getActivity({
                departmentIds: departmentSelection.join(','),
            });
            let option = [];
            // mockActivity?.forEach((element) => {
            data?.resultData?.forEach((element) => {
                option.push({
                    title: element?.activityName,
                    value: element.activityId,
                });
            });
            await setActivityList(option);
        } catch (error) {}
    };
    useEffect(() => {
        getActivity(departmentSelection);
    }, [departmentSelection]);

    //Delete Application
    const [dataObject, setDataObject] = useState();
    const [loadingDelete, setLoadingDelete] = useState(false);
    const deleteApplication = async (id) => {
        setLoadingDelete(true);
        try {
            const { data } = await ConsentService.deleteApplication(
                consentDetail?.consentId,
                id
            );
            if (data?.resultMsg === 'SUCCESS') {
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                    timeOut: 1800,
                });
                await getApplicationList();
            }
        } catch (error) {
            const data = error?.data;
            if (data?.errorData?.msg?.includes('CANNOT BE DELETED')) {
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    timeOut: 20000,
                    closeable: true,
                    type: 'alert',
                    title: t('Consent.titleDelete1'),
                    description: t('Consent.desDelete1'),
                });
            } else {
                setOpenDelete(false);
                setLoadingDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to deleted data.'),
                });
            }
        }
    };

    // Data Subject Type
    const getDataSubject = async (activitySelection) => {
        try {
            const { data } = await ConsentService.getDataSubject({
                activityIds: activitySelection?.join(','),
            });
            let option = [];
            data?.resultData?.forEach((element) => {
                option.push(
                    lang === 'en'
                        ? element.dataSubjectName
                        : element.dataSubjectName
                );
            });
            await setDsType(option);
        } catch (error) {}
    };

    useEffect(() => {
        getDataSubject(activitySelection);
    }, [activitySelection]);

    const getImage = async (id) => {
        const item = await GlobalService.getImage(id).then(({ data }) => {
            return `data:image/png;base64,${data.resultData?.imageId}`;
        });
        return item;
    };

    // Application
    const [loadingApp, setLoadingApp] = useState(false);
    const getApplicationList = async () => {
        setLoadingApp(true);
        try {
            const { data } = await ConsentService.getApplicationRelated();
            const item = data?.resultData;
            const newItem = [];
            for (let _data of item) {
                let img = '';
                if (_data?.applicationLogoId) {
                    img = await getImage(_data?.applicationLogoId);
                }
                newItem.push({
                    image: img ? img : '',
                    ..._data,
                });
            }

            await setApplicationList(newItem);
            await setLoadingApp(false);
        } catch (error) {}
    };
    useEffect(() => {
        getApplicationList();
        // setApplicationList(mockApplicationRelated)
    }, []);

    const getNextVersion = () => {
        let item = '';
        let version = consentDetail?.latestPublishedVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.latestPublishedVersion}
                    </Tag>
                );
            default:
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        Draft 0000.0
                    </Tag>
                );
        }
    };

    const onFinish = async (value) => {
        if (openPublish) {
            const payloadSave = {
                departmentIds: value?.departmentIds || [],
                activityIds: value?.activityIds || [],
                applicationIds: currentSelectList || [],
                consentType: value?.consentType, //"Consent", "Term & Condition"
                consentNameTh: value?.consentNameTh,
                consentNameEn: value?.consentNameEn,
                isConsented: isAccept,
                purposeTh: value?.purposeTh,
                purposeEn: value?.purposeEn,
                isPublish: true, //true=save, false=save&publish
                noExpirationDate: duration,
                expirationYear: value?.expirationYear,
                expirationMonth: value?.expirationMonth,
                expirationDate: value?.expirationDate,
                consentDuration: consentDuration,
            };
            if (id !== 'new') {
                payloadSave['consentId'] = id;
            }
            setPublishData(payloadSave);
            setOpenConfirm(true);
        } else {
            const payloadSave = {
                departmentIds: value?.departmentIds || [],
                activityIds: value?.activityIds || [],
                applicationIds: currentSelectList || [],
                consentType: value?.consentType, //"Consent", "Term & Condition"
                consentNameTh: value?.consentNameTh,
                consentNameEn: value?.consentNameEn,
                isConsented: isAccept,
                purposeTh: value?.purposeTh,
                purposeEn: value?.purposeEn,
                isPublish: false, //true=save&publish, false=save
                noExpirationDate: duration,
                expirationYear: value?.expirationYear,
                expirationMonth: value?.expirationMonth,
                expirationDate: value?.expirationDate,
                consentDuration: consentDuration,
            };
            if (id !== 'new') {
                payloadSave['consentId'] = id;
            }
            try {
                setLoadingSave(true);
                if (id === 'new') {
                    const { data } = await ConsentService.addConsent(
                        payloadSave
                    );
                    if (data?.resultMsg === 'SUCCESS') {
                        setChange(false);
                        setLoadingSave(false);
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully save data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            navigate(ROUTER.CONSENT_MANAGEMENT.CONSENT);
                        }, 1900);
                    } else {
                        setOpenConfirm(false);
                        setLoadingSave(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submit data'),
                        });
                    }
                } else {
                    const { data } = await ConsentService.editConsent(
                        payloadSave
                    );
                    if (data?.resultMsg === 'SUCCESS') {
                        setChange(false);
                        setOpenConfirm(false);
                        setLoadingSave(false);
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully saved data'),
                            timeOut: 1800,
                        });
                        setTimeout(() => {
                            navigate(ROUTER.CONSENT_MANAGEMENT.CONSENT);
                        }, 1900);
                    } else {
                        setOpenConfirm(false);
                        setLoadingSave(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submit data'),
                        });
                    }
                }
            } catch (error) {}
        }
    };

    return (
        <>
            <div>
                <div className="title flex">
                    <div
                        className="cursor-pointer mr-3"
                        onClick={() => {
                            navigate(-1);
                            navigate(ROUTER.CONSENT_MANAGEMENT.CONSENT);
                        }}
                    >
                        <IconBack />
                    </div>{' '}
                    {id === 'new'
                        ? t('Consent.AddConsent')
                        : t('Consent.EditConsent')}{' '}
                </div>
                <div className="sub-title">
                    <span className="text-sm text-gray-400">
                        {t('common.ConsentManagement')} /
                    </span>
                    <span className="text-sm text-gray-400">
                        {' '}
                        {t('common.Consent')} /
                    </span>
                    <span>
                        {' '}
                        {id === 'new'
                            ? t('Consent.AddConsent')
                            : t('Consent.EditConsent')}{' '}
                    </span>
                </div>
            </div>
            <div className="w-full ">
                <Spin spinning={loadingApp}>
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        form={form}
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0) {
                                setChange(true);
                            }
                        }}
                        onFinish={onFinish}
                        layout="vertical"
                        className="space-y-2"
                    >
                        <div className="bg-white rounded-md p-8 my-4">
                            <div className="flex items-center justify-between">
                                <div className="flex gap-2 items-center">
                                    <div className="font-semibold text-2xl">
                                        {id === 'new'
                                            ? t('Consent.AddConsent')
                                            : t('Consent.EditConsent')}{' '}
                                    </div>
                                    {_getTagStatus(
                                        id === 'new' ? 'Draft' : consentDetail
                                    )}
                                    {consentDetail?.latestPublishedDate ? (
                                        <div className="text-sm text-[#65707A]">
                                            {t('Consent.PublishedDate')} :{' '}
                                            {consentDetail?.latestPublishedDate ||
                                                '-'}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="flex gap-x-2">
                                    <div
                                        className="flex-column items-center text-[12px] text-right"
                                        hidden={
                                            id === 'new' ||
                                            consentDetail?.status === 'Draft' ||
                                            consentDetail?.version ===
                                                consentDetail?.latestPublishedVersion
                                        }
                                    >
                                        <div
                                            hidden={
                                                consentDetail?.version?.split(
                                                    '.'
                                                )[0] === '0000'
                                            }
                                        >
                                            {t('Consent.Version')} :{' '}
                                            {consentDetail?.version}
                                        </div>
                                        <div className="text-[#F0536F]">
                                            <span className="text-xl align-middle">
                                                &#8226;
                                            </span>{' '}
                                            {t('Consent.DataChanged')}
                                        </div>
                                    </div>
                                    <Button
                                        size="large"
                                        // type="default"
                                        loading={loadingSave}
                                        type="primary"
                                        className="w-[140px] text-tiny"
                                        htmlType="submit"
                                        ghost
                                        onClick={() => {
                                            setOpenPublish(false);
                                        }}
                                    >
                                        {t('Consent.Save')}
                                    </Button>
                                    <Button
                                        size="large"
                                        type="primary"
                                        loading={loadingSave}
                                        className="w-[140px] text-tiny"
                                        htmlType="submit"
                                        onClick={() => {
                                            setOpenPublish(true);
                                        }}
                                    >
                                        {t('Consent.Save&Publish')}
                                    </Button>
                                </div>
                            </div>
                            <Divider className="border-[3px] border-[#F4F6FC] my-4" />
                            <div className="w-[50%]">
                                <div className="font-semibold text-xl">
                                    {t('Consent.Title1')}
                                </div>
                                <Form.Item
                                    label={
                                        <span className="font-semibold text-sm">
                                            {t('Consent.FilterDepartment')}
                                        </span>
                                    }
                                    name="departmentIds"
                                >
                                    <TreeSelect
                                        treeCheckable
                                        size="large"
                                        filterTreeNode={(search, item) => {
                                            return (
                                                String(item?.title)
                                                    ?.toLowerCase()
                                                    ?.indexOf(
                                                        search?.toLowerCase()
                                                    ) >= 0
                                            );
                                        }}
                                        placeholder={t(
                                            'Consent.SearchDepartmentName'
                                        )}
                                        showCheckedStrategy={
                                            TreeSelect.SHOW_CHILD
                                        }
                                        dropdownStyle={{ maxHeight: '300px' }}
                                        onChange={(ids) => {
                                            setActivitySelection();
                                            setActivityList();
                                            form.setFieldsValue({
                                                activityIds: [],
                                            });
                                            setDepartmentSelection(ids);
                                        }}
                                        showArrow
                                        treeData={
                                            departmentList?.length > 0
                                                ? [
                                                      {
                                                          title:
                                                              departmentSelection?.length ===
                                                              departmentList?.length ? (
                                                                  <button
                                                                      onClick={() => {
                                                                          setDepartmentSelection(
                                                                              []
                                                                          );
                                                                          form.setFieldsValue(
                                                                              {
                                                                                  departmentIds:
                                                                                      [],
                                                                              }
                                                                          );
                                                                          setActivitySelection(
                                                                              []
                                                                          );
                                                                          form.setFieldsValue(
                                                                              {
                                                                                  activityIds:
                                                                                      [],
                                                                              }
                                                                          );
                                                                      }}
                                                                      style={{
                                                                          display:
                                                                              'inline-block',
                                                                          color: '#286FBE',
                                                                          cursor: 'pointer',
                                                                      }}
                                                                  >
                                                                      {t(
                                                                          `Consent.UnselectAll`
                                                                      )}
                                                                  </button>
                                                              ) : (
                                                                  <button
                                                                      onClick={() => {
                                                                          setDepartmentSelection(
                                                                              departmentList.map(
                                                                                  (
                                                                                      e
                                                                                  ) =>
                                                                                      e.value
                                                                              )
                                                                          );
                                                                          form.setFieldsValue(
                                                                              {
                                                                                  departmentIds:
                                                                                      departmentList.map(
                                                                                          (
                                                                                              e
                                                                                          ) =>
                                                                                              e.value
                                                                                      ),
                                                                              }
                                                                          );
                                                                      }}
                                                                      style={{
                                                                          display:
                                                                              'inline-block',
                                                                          color: '#286FBE',
                                                                          cursor: 'pointer',
                                                                      }}
                                                                  >
                                                                      {t(
                                                                          `Consent.SelectAll`
                                                                      )}
                                                                  </button>
                                                              ),
                                                          value: 'xxx',
                                                          disableCheckbox: true,
                                                          disabled: true,
                                                          checkable: false,
                                                      },
                                                      ...departmentList,
                                                  ]
                                                : []
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span className="font-semibold text-sm">
                                            {t('Consent.ActivityRelated')}
                                        </span>
                                    }
                                    name="activityIds"
                                >
                                    <TreeSelect
                                        disabled={
                                            departmentSelection?.length <= 0
                                        }
                                        treeCheckable
                                        size="large"
                                        filterTreeNode={(search, item) => {
                                            return (
                                                String(item?.title)
                                                    ?.toLowerCase()
                                                    ?.indexOf(
                                                        search?.toLowerCase()
                                                    ) >= 0
                                            );
                                        }}
                                        placeholder={t(
                                            'Consent.SearchActivityName'
                                        )}
                                        showCheckedStrategy={
                                            TreeSelect.SHOW_CHILD
                                        }
                                        dropdownStyle={{ maxHeight: '300px' }}
                                        onChange={(ids) =>
                                            setActivitySelection(ids)
                                        }
                                        showArrow
                                        treeData={
                                            activityList?.length > 0
                                                ? [
                                                      {
                                                          title:
                                                              activitySelection?.length ===
                                                              activityList?.length ? (
                                                                  <button
                                                                      onClick={() => {
                                                                          setActivitySelection(
                                                                              []
                                                                          );
                                                                          form.setFieldsValue(
                                                                              {
                                                                                  activityIds:
                                                                                      [],
                                                                              }
                                                                          );
                                                                      }}
                                                                      style={{
                                                                          display:
                                                                              'inline-block',
                                                                          color: '#286FBE',
                                                                          cursor: 'pointer',
                                                                      }}
                                                                  >
                                                                      {t(
                                                                          `Consent.UnselectAll`
                                                                      )}
                                                                  </button>
                                                              ) : (
                                                                  <button
                                                                      onClick={() => {
                                                                          setActivitySelection(
                                                                              activityList.map(
                                                                                  (
                                                                                      e
                                                                                  ) =>
                                                                                      e.value
                                                                              )
                                                                          );
                                                                          form.setFieldsValue(
                                                                              {
                                                                                  activityIds:
                                                                                      activityList.map(
                                                                                          (
                                                                                              e
                                                                                          ) =>
                                                                                              e.value
                                                                                      ),
                                                                              }
                                                                          );
                                                                      }}
                                                                      style={{
                                                                          display:
                                                                              'inline-block',
                                                                          color: '#286FBE',
                                                                          cursor: 'pointer',
                                                                      }}
                                                                  >
                                                                      {t(
                                                                          `Consent.SelectAll`
                                                                      )}
                                                                  </button>
                                                              ),
                                                          value: 'xxx',
                                                          disableCheckbox: true,
                                                          disabled: true,
                                                          checkable: false,
                                                      },
                                                      ...activityList,
                                                  ]
                                                : []
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span className="font-semibold text-sm">
                                            {t('Consent.DataSubjectType')}
                                        </span>
                                    }
                                >
                                    {dsType?.length > 0
                                        ? dsType?.join(', ')
                                        : '-'}
                                </Form.Item>
                            </div>
                            <div className="w-full">
                                <Form.Item
                                    label={
                                        <span className="font-semibold text-sm">
                                            {t('Consent.ApplicationRelated')}
                                        </span>
                                    }
                                    name="applicationList"
                                >
                                    <div className=" items-center">
                                        <div className="w-full">
                                            <Tag
                                                // key={e.policyTypeId}
                                                className={`mr-2 mb-2 cursor-pointer hover:opacity-80 hover:scale-x-105 duration-150 rounded-full px-3 py-2 border-dashed border-[1px] border-[#1890FF] ${
                                                    true === 1 ? 'select' : ''
                                                } space-x-4`}
                                                // onClick={() => {
                                                //     setCurrentSelect(1);
                                                // }}
                                                // style={{margin:'0px'}}
                                                onClick={() => {
                                                    setOpenAddApplication(true);
                                                }}
                                            >
                                                <div className="flex items-center">
                                                    <img
                                                        className="w-7 h-7 p-1 rounded-full object-cover"
                                                        src={circlePlus}
                                                        alt=""
                                                    />
                                                    <div className="font-semibold text-xs">
                                                        {t(
                                                            'Consent.AddApplication'
                                                        )}
                                                    </div>
                                                </div>
                                            </Tag>
                                            <span className="items-center">
                                                {applicationList?.map((res) => (
                                                    <label
                                                        key={res?.applicationId}
                                                        className="radio-toolbar inline-block mr-2 mb-2"
                                                    >
                                                        <input
                                                            checked={currentSelectList?.find(
                                                                (s) =>
                                                                    s ===
                                                                    res?.applicationId
                                                            )}
                                                            type="checkbox"
                                                            onClick={() => {
                                                                const selected =
                                                                    currentSelectList ||
                                                                    [];
                                                                const check =
                                                                    selected?.find(
                                                                        (s) =>
                                                                            s ===
                                                                            res?.applicationId
                                                                    );
                                                                if (check) {
                                                                    setCurrentSelectList(
                                                                        selected.filter(
                                                                            (
                                                                                data
                                                                            ) =>
                                                                                data !==
                                                                                res?.applicationId
                                                                        )
                                                                    );
                                                                } else {
                                                                    selected.push(
                                                                        res?.applicationId
                                                                    );
                                                                    setCurrentSelectList(
                                                                        selected
                                                                    );
                                                                }
                                                            }}
                                                        />

                                                        <div className="r-label-color p-0.5 rounded-full hover:opacity-80 hover:scale-x-105 duration-150 border-solid border-[#DBDBDB]">
                                                            <div className="w-300 h-10 rounded-full border-2 cursor-pointer flex">
                                                                <div className="flex gap-2 items-center px-2">
                                                                    <img
                                                                        className="w-7 h-7 rounded-full object-cover"
                                                                        src={
                                                                            res?.applicationLogoId
                                                                                ? res?.image
                                                                                : noImage
                                                                        }
                                                                        alt=""
                                                                    />
                                                                    <div className="font-semibold text-sm">
                                                                        {
                                                                            res?.applicationName
                                                                        }
                                                                    </div>
                                                                    <Dropdown
                                                                        placement="bottomCenter"
                                                                        arrow
                                                                        overlay={menu(
                                                                            res
                                                                        )}
                                                                    >
                                                                        <div
                                                                            className={
                                                                                'r-label hover:opacity-80 rounded-lg text-center w-7 h-7 bg-[#F3F6F9]'
                                                                            }
                                                                        >
                                                                            <svg
                                                                                width="12"
                                                                                height="4"
                                                                                viewBox="0 0 12 4"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M8.61279 1.77441C8.61279 2.54785 9.24561 3.18066 10.019 3.18066C10.7925 3.18066 11.4253 2.54785 11.4253 1.77441C11.4253 1.00098 10.7925 0.368164 10.019 0.368164C9.24561 0.368164 8.61279 1.00098 8.61279 1.77441Z"
                                                                                    fill="#7B67FB"
                                                                                />
                                                                                <path
                                                                                    d="M7.20654 1.77441C7.20654 1.00098 6.57373 0.368164 5.80029 0.368164C5.02686 0.368164 4.39404 1.00098 4.39404 1.77441C4.39404 2.54785 5.02686 3.18066 5.80029 3.18066C6.57373 3.18066 7.20654 2.54785 7.20654 1.77441Z"
                                                                                    fill="#7B67FB"
                                                                                />
                                                                                <path
                                                                                    d="M2.98779 1.77441C2.98779 1.00098 2.35498 0.368164 1.58154 0.368164C0.808106 0.368164 0.175293 1.00098 0.175293 1.77441C0.175293 2.54785 0.808106 3.18066 1.58154 3.18066C2.35498 3.18066 2.98779 2.54785 2.98779 1.77441Z"
                                                                                    fill="#7B67FB"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                ))}
                                            </span>
                                        </div>
                                    </div>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="bg-white rounded-md p-8 my-4">
                            <div className="text-[#7B67FB] text-xl font-semibold pb-4">
                                {t('Consent.Title2')}
                            </div>
                            <div className="w-[50%]">
                                <Form.Item
                                    label={
                                        <span className="font-semibold text-base">
                                            {t('Consent.ConsentType')}
                                        </span>
                                    }
                                    name="consentType"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={t(
                                            'Consent.SelectConsentType'
                                        )}
                                        size="large"
                                        onChange={(e) => {
                                            if (e === 'Consent') {
                                                setIsAccept(false);
                                                setDisabledIsConsent(false);
                                            } else {
                                                setIsAccept(true);
                                                setDisabledIsConsent(true);
                                            }
                                        }}
                                    >
                                        {consentType?.map((e) => (
                                            <Option
                                                key={e?.consentTypeId}
                                                value={e?.consentTypeId}
                                            >
                                                {e.consentTypeName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item>
                                    <div className="bg-[#F4F6FC] w-full flex items-center rounded-md px-3 py-[10px]">
                                        <Checkbox
                                            disabled={disabledIsConsent}
                                            checked={isAccept}
                                            onChange={(e) => {
                                                setIsAccept(e.target.checked);
                                            }}
                                        >
                                            {t(
                                                'Consent.RequiredConsentCheckDetail'
                                            )}
                                        </Checkbox>
                                    </div>
                                </Form.Item>
                                <span className="font-[600] text-base">
                                    {t('Consent.ConsentName')}{' '}
                                    <div className="requiredCustom">*</div>{' '}
                                    {'(TH)'}
                                </span>
                                <Form.Item
                                    name="consentNameTh"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={t(
                                            'Consent.PleaseSpecifyInformationTh'
                                        )}
                                        size="large"
                                        maxLength={200}
                                        showCount
                                    ></Input>
                                </Form.Item>
                                <span className="font-[600] text-base">
                                    {t('Consent.ConsentName')}{' '}
                                    {/* <span className='text-[#F0536F]'>*</span>  */}
                                    {'(EN)'}
                                </span>
                                <Form.Item
                                    // label={
                                    //     <span className="font-semibold text-sm">
                                    //         Consent Type
                                    //     </span>
                                    // }
                                    name="consentNameEn"
                                >
                                    <Input
                                        placeholder={t(
                                            'Consent.PleaseSpecifyInformationEn'
                                        )}
                                        size="large"
                                        maxLength={200}
                                        showCount
                                    ></Input>
                                </Form.Item>
                                <div className="w-full flex-col items-center rounded-md px-3 py-[10px]">
                                    <div className="font-[600] text-base">
                                        {t('Consent.DurationOfConsent')}{' '}
                                        {/* <span className="text-[#F0536F] font-normal">
                                            *
                                        </span> */}
                                        <div className="requiredCustom">*</div>
                                    </div>
                                    <div className="text-[#F0536F]">
                                        {t('Consent.HintDurationOfConsent')}
                                    </div>
                                    <div className="my-3">
                                        <Checkbox
                                            checked={duration}
                                            onChange={(e) => {
                                                setDuration(e.target.checked);
                                                setConsentDuration('0');
                                                form.resetFields([
                                                    'expirationYear',
                                                    'expirationMonth',
                                                    'expirationDate',
                                                ]);
                                            }}
                                        >
                                            {t(
                                                'Consent.DurationOfConsentCheck'
                                            )}
                                        </Checkbox>
                                    </div>
                                    <div className="flex gap-2 w-[100%]">
                                        <Form.Item>
                                            <Space>
                                                <Form.Item
                                                    noStyle
                                                    name="expirationYear"
                                                    rules={[
                                                        {
                                                            // ^[0-9]\d*$
                                                            pattern: new RegExp(
                                                                /^[0-9]\d*$/
                                                            ),
                                                            message: t(
                                                                'errorText.validateFieldInvalid'
                                                            ),
                                                        },
                                                        {
                                                            required: !duration,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        className="w-[100px] h-[40px]"
                                                        size="large"
                                                        placeholder="0"
                                                        disabled={duration}
                                                        onChange={(e) => {
                                                            const year =
                                                                e.target
                                                                    .value || 0;
                                                            const month =
                                                                form.getFieldsValue()
                                                                    ?.expirationMonth ||
                                                                0;
                                                            const date =
                                                                form.getFieldsValue()
                                                                    ?.expirationDate ||
                                                                0;
                                                            const sum =
                                                                Number(year) *
                                                                    365 +
                                                                Number(month) *
                                                                    30 +
                                                                Number(date);
                                                            setConsentDuration(
                                                                sum
                                                            );
                                                        }}
                                                    />
                                                </Form.Item>
                                                <span className="pt-2 pr-5">
                                                    {t('Consent.Year')}
                                                </span>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item>
                                            <Space>
                                                <Form.Item
                                                    noStyle
                                                    name="expirationMonth"
                                                    rules={[
                                                        {
                                                            // ^[0-9]\d*$
                                                            pattern: new RegExp(
                                                                /^[0-9]\d*$/
                                                            ),
                                                            message: t(
                                                                'errorText.validateFieldInvalid'
                                                            ),
                                                        },
                                                        {
                                                            required: !duration,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        className="w-[100px] h-[40px]"
                                                        size="large"
                                                        placeholder="0"
                                                        disabled={duration}
                                                        onChange={(e) => {
                                                            const year =
                                                                form.getFieldsValue()
                                                                    ?.expirationYear ||
                                                                0;
                                                            const month =
                                                                e.target
                                                                    .value || 0;
                                                            const date =
                                                                form.getFieldsValue()
                                                                    ?.expirationDate ||
                                                                0;
                                                            const sum =
                                                                Number(year) *
                                                                    365 +
                                                                Number(month) *
                                                                    30 +
                                                                Number(date);
                                                            setConsentDuration(
                                                                sum
                                                            );
                                                        }}
                                                    />
                                                </Form.Item>
                                                <span className="pt-2 pr-5">
                                                    {t('Consent.Month')}
                                                </span>
                                            </Space>
                                        </Form.Item>
                                        <Form.Item>
                                            <Space>
                                                <Form.Item
                                                    noStyle
                                                    name="expirationDate"
                                                    rules={[
                                                        {
                                                            // ^[0-9]\d*$
                                                            pattern: new RegExp(
                                                                /^[0-9]\d*$/
                                                            ),
                                                            message: t(
                                                                'errorText.validateFieldInvalid'
                                                            ),
                                                        },
                                                        {
                                                            required: !duration,
                                                            message: t(
                                                                'errorText.requiredField'
                                                            ),
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        className="w-[100px] h-[40px]"
                                                        size="large"
                                                        placeholder="0"
                                                        disabled={duration}
                                                        onChange={(e) => {
                                                            const year =
                                                                form.getFieldsValue()
                                                                    ?.expirationYear ||
                                                                0;
                                                            const month =
                                                                form.getFieldsValue()
                                                                    ?.expirationMonth ||
                                                                0;
                                                            const date =
                                                                e.target
                                                                    .value || 0;
                                                            const sum =
                                                                Number(year) *
                                                                    365 +
                                                                Number(month) *
                                                                    30 +
                                                                Number(date);
                                                            setConsentDuration(
                                                                sum
                                                            );
                                                        }}
                                                    />
                                                </Form.Item>
                                                <span className="pt-2 pr-5">
                                                    {t('Consent.Day')}
                                                </span>
                                            </Space>
                                        </Form.Item>
                                        {duration ? (
                                            <div className="bg-[#f5f5f5] h-10 flex items-center py-[6.5px] px-[11px] rounded-md text-[#00000040] border-[1px] border-solid border-[#d9d9d9] ">
                                                <div className="">
                                                    {consentDuration
                                                        ? `${consentDuration} ${t(
                                                              'Consent.Day'
                                                          )}`
                                                        : `${t(
                                                              'Consent.InvalidValue'
                                                          )}`}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="bg-[#f5f6ff] h-10 flex items-center py-[6.5px] px-[11px] rounded-md text-[#1890FF]">
                                                {consentDuration ||
                                                consentDuration === 0
                                                    ? `${consentDuration} ${t(
                                                          'Consent.Day'
                                                      )}`
                                                    : `${t(
                                                          'Consent.InvalidValue'
                                                      )}`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <Divider className="border-[3px] border-[#F4F6FC] my-4" />
                                <span className="font-[600] text-base">
                                    {t('Consent.Purpose')}
                                    <div className="requiredCustom">*</div>
                                    &nbsp;
                                    {'(TH)'}
                                </span>
                                <Form.Item
                                    // label={
                                    //     <span className="font-semibold text-sm">
                                    //         Consent Type
                                    //     </span>
                                    // }
                                    name="purposeTh"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(
                                                'errorText.requiredField'
                                            ),
                                        },
                                    ]}
                                >
                                    <EditorPrivacy
                                        placeholder={t(
                                            'Consent.PleasespecifyTh'
                                        )}
                                    />
                                </Form.Item>
                                <span className="font-[600] text-base">
                                    {t('Consent.Purpose')}{' '}
                                    {/* <span className='text-[#F0536F]'>*</span>  */}
                                    {'(EN)'}
                                </span>
                                <Form.Item name="purposeEn">
                                    <EditorPrivacy
                                        placeholder={t(
                                            'Consent.PleasespecifyEn'
                                        )}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </Spin>
            </div>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                handelOk={async () => {
                    try {
                        setLoadingSave(true);
                        if (id === 'new') {
                            const { data } = await ConsentService.addConsent(
                                publishData
                            );
                            if (data?.resultMsg === 'SUCCESS') {
                                setChange(false);
                                setOpenConfirm(false);
                                setLoadingSave(false);
                                notify({
                                    title: t('common.Success'),
                                    description: t('Successfully saved data'),
                                    timeOut: 1800,
                                });
                                setTimeout(() => {
                                    navigate(ROUTER.CONSENT_MANAGEMENT.CONSENT);
                                }, 1900);
                            } else {
                                setOpenConfirm(false);
                                setLoadingSave(false);
                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('Failed to submit data'),
                                });
                            }
                        } else {
                            const { data } = await ConsentService.editConsent(
                                publishData
                            );
                            if (data?.resultMsg === 'SUCCESS') {
                                setChange(false);
                                setOpenConfirm(false);
                                setLoadingSave(false);
                                notify({
                                    title: t('common.Success'),
                                    description: t('Successfully saved data'),
                                    timeOut: 1800,
                                });
                                setTimeout(() => {
                                    navigate(ROUTER.CONSENT_MANAGEMENT.CONSENT);
                                }, 1900);
                            } else {
                                setOpenConfirm(false);
                                setLoadingSave(false);
                                notify({
                                    type: 'error',
                                    title: t('common.Fail'),
                                    description: t('Failed to submit data'),
                                });
                            }
                        }
                    } catch (error) {}
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Consent.PublishedConsent')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {consentDetail?.latestPublishedVersion
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
            <ModalAddApplication
                open={openAddApplication}
                handelClose={() => setOpenAddApplication(false)}
                editObject={applicationData}
                // handelOk={()=>{getApplicationList()}}
                getApplicationList={getApplicationList}
                setApplicationData={setApplicationData}
            />
            <ModalDelete
                text={t('dataFlow.modalDelete')}
                loading={loadingDelete}
                open={openDelete}
                handelOk={
                    // handelDelete
                    () => {
                        deleteApplication(dataObject?.applicationId);
                    }
                }
                handelClose={() => {
                    setOpenDelete(false);
                }}
            />
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </>
    );
}

const consentType = [
    {
        consentTypeId: 'Consent',
        consentTypeName: 'Consent',
    },
    {
        consentTypeId: 'Term & Condition',
        consentTypeName: 'Term & Condition',
    },
];
